import { Routes, Route } from 'react-router-dom'
import { PacienteEntryPage } from './pages/PacienteEntryPage'
import { VerificacaoTecnicaPage } from './pages/VerificacaoTecnicaPage'
import { SalaEsperaPage } from './pages/SalaEsperaPage'
import { VideochamadaPaciente } from './pages/VideochamadaPaciente'

function App() {
  return (
    <div className="min-h-screen bg-slate-50">
      <Routes>
        <Route path="/teleconsulta/:token" element={<PacienteEntryPage />} />
        <Route path="/teleconsulta/:token/verificacao" element={<VerificacaoTecnicaPage />} />
        <Route path="/teleconsulta/:token/espera" element={<SalaEsperaPage />} />
        <Route path="/teleconsulta/:token/chamada" element={<VideochamadaPaciente />} />
        <Route path="*" element={<div className="flex min-h-screen items-center justify-center text-muted-foreground">Link inválido</div>} />
      </Routes>
    </div>
  )
}

export default App
